import {Button, type ButtonProps} from "@mantine/core";
import {useAuth} from "../context/AuthProvider";

export function LogoutButton(props: ButtonProps) {
  const [{isLoading}, actions] = useAuth();

  return (
    <Button
      type="button"
      onClick={actions.logout}
      loading={isLoading}
      variant="outline"
      color="gray"
      fullWidth
      size="md"
      {...props}
    >
      Sign Out
    </Button>
  );
}
